import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DefectMatchedResultsList from './DefectMatchedResultsList';
import { AutoLinkPatternField } from '../types';

interface DefectMatchedResultsDialogProps {
    open: boolean;
    onClose: () => void;
    pattern: string;
    fieldName: AutoLinkPatternField | null;
}

const DefectMatchedResultsDialog: FC<DefectMatchedResultsDialogProps> = ({ open, onClose, pattern, fieldName }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth sx={{ minWidth: 1100 }}>
            <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{t('view_matched_results')}</DialogTitle>
            <DialogContent>
                <DefectMatchedResultsList pattern={pattern} fieldName={fieldName} />
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={onClose} color="secondary">
                    {t('close')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default DefectMatchedResultsDialog;
